import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Hostname-aware routing for the Driver app.
 *
 *   · Hostname starts with "driver." (e.g. driver.link.hermesmobility.com)
 *     → force every visit to /driver. Drivers landing on /, /schedule, /about
 *       etc. are redirected so the driver subdomain is single-purpose.
 *   · Hostname is anything else → no-op. The /driver route still works for
 *     dev/staging where the same React bundle serves both apps.
 */
const DRIVER_HOST_PREFIX = "driver.";
const PUBLIC_PATHS_ON_DRIVER_HOST = new Set([
  "/", "/about", "/schedule", "/register", "/account", "/trips", "/profile",
]);

export default function DriverSubdomainRedirect() {
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname || "";
    if (!host.startsWith(DRIVER_HOST_PREFIX)) return;

    // Allow auth + the driver page itself; otherwise punt to /driver.
    if (loc.pathname === "/driver" || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/forgot-password")) {
      return;
    }
    if (PUBLIC_PATHS_ON_DRIVER_HOST.has(loc.pathname)) {
      nav("/driver", { replace: true });
    }
  }, [loc.pathname, nav]);

  return null;
}
